// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_m0-0";
export var fileCarousel = "_m0-2";
export var removeFileButton = "_m0-1";